import { ok, type Result } from "neverthrow";

import { mustBeDefined, type NotFoundError } from "@thalamos/common";

import {
  AvailableLanguagesSchema,
  WorkflowVersionSchema,
  type AnyWorkflow,
  type AvailableLanguages,
  type WorkflowVersion,
} from "../types/index.js";
import { workflow_BTP_1_0 } from "./workflow_BTP_1_0/workflow.js";
import { workflow_BTP_1_1 } from "./workflow_BTP_1_1/workflow.js";
import { workflow_BTP_1_2 } from "./workflow_BTP_1_2/workflow.js";
import { workflow_COLP_1_0 } from "./workflow_COLP_1_0/workflow.js";
import { workflow_MET_1_0 } from "./workflow_MET_1_0/workflow.js";

export const workflows: Record<string, AnyWorkflow> = {
  [WorkflowVersionSchema.enum.BTP_1_0]: workflow_BTP_1_0,
  [WorkflowVersionSchema.enum.BTP_1_1]: workflow_BTP_1_1,
  [WorkflowVersionSchema.enum.BTP_1_2]: workflow_BTP_1_2,
  [WorkflowVersionSchema.enum.MET_1_0]: workflow_MET_1_0,
  [WorkflowVersionSchema.enum.COLP_1_0]: workflow_COLP_1_0,
} satisfies Record<WorkflowVersion, AnyWorkflow>;

/**
 * A workflow version reaches us as an unconstrained string off the wire or out
 * of the database, so a lookup can miss even though the registry is total over
 * `WorkflowVersion`.
 */
export const getWorkflow = (
  workflowVersion: string,
): Result<AnyWorkflow, NotFoundError> =>
  ok(workflows[workflowVersion]).andThen(
    mustBeDefined(`Unknown workflow version: ${workflowVersion}`),
  );

export const workflowVersionToLanguage = {
  [WorkflowVersionSchema.enum.BTP_1_0]:
    AvailableLanguagesSchema.enum.BritishTransportPolice,
  [WorkflowVersionSchema.enum.BTP_1_1]:
    AvailableLanguagesSchema.enum.BritishTransportPolice,
  [WorkflowVersionSchema.enum.BTP_1_2]:
    AvailableLanguagesSchema.enum.BritishTransportPolice,
  [WorkflowVersionSchema.enum.COLP_1_0]:
    AvailableLanguagesSchema.enum.CityOfLondonPolice,
  [WorkflowVersionSchema.enum.MET_1_0]:
    AvailableLanguagesSchema.enum.MetropolitanPolice,
} as const satisfies {
  [K in WorkflowVersion]: AvailableLanguages;
};

export {
  workflow_BTP_1_0,
  workflow_BTP_1_1,
  workflow_BTP_1_2,
  workflow_MET_1_0,
  workflow_COLP_1_0,
};
